// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DISPLAY_QUANTITY_IN_LOTS_V as DISPLAY_QUANTITY_IN_LOTS } from './UtilsClasses/BaseGeneralSettingsUtils';
export class SessionSettingsConst {
}
// Trading defaults:
SessionSettingsConst.SET_SLTP_VALUES_IN_OFFSET = 'sltpOffsetMode';
SessionSettingsConst.SHOW_OFFSET_IN = 'property.OffsetMode';
SessionSettingsConst.USE_STOP_LIMIT_INSTEAD_OF_STOP = 'property.useStopLimitInsteadStop';
// Confirmations:
SessionSettingsConst.CONFIRM_ORDER_PLACEMENT = 'property.oe.confirmOrderCreate';
SessionSettingsConst.CONFIRM_ORDER_CANCELLATION = 'property.oe.confirmOrderCancel';
SessionSettingsConst.CONFIRM_ORDER_OR_POSITION_MODIFICATION = 'property.oe.confirmOrderChange';
SessionSettingsConst.CONFIRM_POSITION_CLOSING = 'property.oe.confirmClosePosition';
SessionSettingsConst.CONFIRM_ALERT_REMOVE = 'property.oe.confirmAlertRemove';
SessionSettingsConst.SHOW_DEAL_TICKETS = 'property.dealTickets.showDealTickets';
SessionSettingsConst.SHOW_MARGIN_DEAL_TICKETS_ON_WORKSPACE = 'property.dealTickets.showMarginDealTicketsOnWorkspace';
SessionSettingsConst.CONFIRM_ACCOUNT_FOLLOWING = 'panel.CopyTrading.ShowConfirmationLabel';
// Warnings:
SessionSettingsConst.PANEL_COPY_TRADING_WARNING_HIDING_SETTINGS_TEXT = 'panel.CopyTrading.Warning.Settings.Text';
SessionSettingsConst.PANEL_COPY_TRADING_WARNING_AFTER_RELOGIN_SETTINGS_TEXT = 'panel.CopyTrading.Warning.AfterRelogin.Settings.Text';
// View:
SessionSettingsConst.IS_ROUNDED_AVERAGE_OPEN_PRICE = 'property.IsRoundedAvgPrice';
SessionSettingsConst.DISPLAY_QUANTITY_IN_LOTS = DISPLAY_QUANTITY_IN_LOTS;
SessionSettingsConst.REVERSE_BUTTONS_ORDER = 'property.cellscin.useSellBuy';
SessionSettingsConst.ABBREVIATE_VOLUMES = 'property.abbreviateVolumes';
SessionSettingsConst.TOOLTIPS = 'property.isShowToolTips';
// Types manager:
SessionSettingsConst.TYPES_MANAGER = 'instruments_defaults';
